/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const NavigationAlertContext = createContext(null);

export const NavigationAlertProvider = ({ children }) => {
  const navigate = useNavigate();
  const [alert, setAlert] = useState(null);
  const [status, setStatus] = useState(null);

  const handleNavigation = (path, alertMessage = null, alertStatus = 'error', errorMessage = null) => {
    if (alertMessage) {
      setAlert(alertMessage);
      setStatus(alertStatus);
    }
    navigate(path, { state: { errorPageMessage: errorMessage } });
  };

  return (
    <NavigationAlertContext.Provider value={{ handleNavigation, alert, setAlert, status, setStatus }}>
      {children}
    </NavigationAlertContext.Provider>
  );
};

export const useNavigationAlert = () => useContext(NavigationAlertContext);
